class ProductForm extends HTMLElement {
	constructor() {
		super()
		this.formId = `ProductForm-${this.getAttribute("data-section-id")}`
		this.form = this.querySelector(`#${this.formId}`)
		this.formDataObject = {}
		this.previousFormDataObject = {}
		this.packSelectionComponent = document.querySelector("pack-selection-component")
		this.productVariantDescriptions = document.querySelector(".product__variants_description")
		this.productDataEl = document.querySelector('[id^="ProductJson-"]') // use your product.id

		//Trigger form change to fill the empty data.
		setTimeout(() => {
			const _form_change_event = new Event("change", {bubbles: true})
			this.form.dispatchEvent(_form_change_event)
		})
	}
	connectedCallback() {
		this.form.querySelectorAll(".product__variant_id").forEach(variantInput => {
			variantInput.addEventListener("change", () => {
				if (document.querySelector("pack-selection-component")) document.querySelector("pack-selection-component").reset()
			})
		})

		this.form.addEventListener("change", () => {
			this.previousFormDataObject = this.formDataObject
			const formData = new FormData(this.form)
			this.formDataObject = {}
			formData.forEach((value, key) => (this.formDataObject[key] = key in this.formDataObject ? [].concat(this.formDataObject[key], value) : value))

			//Update the product variant id URL at the browser.
			updateVariantUrl(this.formDataObject.id)

			//Change gallery if it's available
			const gallery = document.querySelector(`media-gallery[data-product-id="${this.formDataObject["product-id"]}"]`)
			if (gallery) {
				gallery.setActiveGroup(this.formDataObject.id)
			}

			if (this.productVariantDescriptions) {
				this.productVariantDescriptions.querySelectorAll(".product__variant_description").forEach(variantDescription => variantDescription.classList.add("hidden"))
				if (this.productVariantDescriptions.querySelector(`.product__variant_description__${this.formDataObject.id}`)) {
					this.productVariantDescriptions.querySelector(`.product__variant_description__${this.formDataObject.id}`).classList.remove("hidden")
				}
			}

			try {
				//Calculate total price for the pack choosing section.
				const selectedVariants = [],
					selectedPack = this.packSelectionComponent ? this.packSelectionComponent.selectedPack : 0,
					currentProduct = JSON.parse(this.productDataEl.textContent)

				//Make sure is a matching number of products
				this.packSelectionComponent.querySelectorAll(".product-slot-item").forEach(item => {
					const variant = currentProduct.variants.filter(_variant => _variant.id === Number(item.dataset.id)).reduce(t => t)
					selectedVariants.push(variant)
				})

				let totalPrice = selectedVariants.reduce((sum, item) => sum + item.price, 0)
				const originalPrice = totalPrice

				if (selectedVariants.length === 2) totalPrice = totalPrice - totalPrice * 0.1 //Apply 10% discount.
				if (selectedVariants.length === 3) totalPrice = totalPrice - totalPrice * 0.15 //Apply 15% discount.

				let subscriptionTotalPrice = totalPrice - totalPrice * 0.1 //Apply 10% discount.
				let subscriptionTotalPriceFormatted = Shopify.formatMoney(subscriptionTotalPrice)

				const totalPriceFormatted = Shopify.formatMoney(totalPrice)
				const originalPriceFormatted = Shopify.formatMoney(originalPrice)

				//If 2 packs or 3 packs selected cross the original price and add a new one next to it with the new price.
				if (selectedVariants.length >= 2) {
					this.form.querySelector(".__product_final_price_one_time").innerText = totalPriceFormatted
					this.form.querySelector(".__product_original_price_one_time").innerText = originalPriceFormatted
					this.form.querySelector(".__product_original_price_one_time").classList.remove("hidden")
				} else {
					this.form.querySelector(".__product_final_price_one_time").innerText = originalPriceFormatted
					this.form.querySelector(".__product_original_price_one_time").innerText = ""
					this.form.querySelector(".__product_original_price_one_time").classList.add("hidden")
				}

				this.form.querySelector(".__product_original_price_subscription").innerText = totalPriceFormatted
				this.form.querySelector(".__product_finale_price_subscription").innerText = subscriptionTotalPriceFormatted
			} catch (error) {
				console.warn(error)
			}
		})

		this.form.addEventListener("submit", async event => {
			//If only one pack just submit the form
			//If it's more than one pack make sure to validate before submittion.
			event.preventDefault()

			const selectedPack = this.packSelectionComponent ? this.packSelectionComponent.selectedPack : 0 //you can skip loads of validations by cheesing this one and adding a 0 that means the products doesn't have packs selection.
			const data = this.formDataObject

			if (selectedPack > 1) {
				const selectedProducts = []
				//Make sure is a matching number of products
				this.packSelectionComponent.querySelectorAll(".product-slot-item").forEach(item => {
					const _item = {
						id: Number(item.dataset.id),
						qty: 1,
						properties: {
							"Pack Size": selectedPack,
						},
					}

					if (data.selling_plan_option === "subscribe") {
						_item.selling_plan = data.selling_plan
					}

					selectedProducts.push(_item)
				})

				if (selectedProducts.length < selectedPack) return

				//Send the products to cart.
				this.form.classList.add("loading")

				const cartAddRequest = await fetch("/cart/add.js", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						items: selectedProducts,
						sections: "cart-drawer",
					}),
				}).then(res => res.json())

				this.form.classList.remove("loading")

				// Parse it as HTML so we can grab only what's inside
				const html = cartAddRequest.sections["cart-drawer"]
				const parser = new DOMParser()
				const doc = parser.parseFromString(html, "text/html")
				document.querySelector("cart-drawer").replaceWith(doc.querySelector("cart-drawer"))
				document.querySelector("cart-drawer").openDrawer()
			} else {
				//Just add it as a normal product.
				this.form.classList.add("loading")
				data.sections = "cart-drawer"
				const cartAddRequest = await fetch("/cart/add.js", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(data),
				}).then(res => res.json())
				this.form.classList.remove("loading")

				// Parse it as HTML so we can grab only what's inside
				const html = cartAddRequest.sections["cart-drawer"]
				const parser = new DOMParser()
				const doc = parser.parseFromString(html, "text/html")
				document.querySelector("cart-drawer").replaceWith(doc.querySelector("cart-drawer"))
				document.querySelector("cart-drawer").openDrawer()
			}

			return document.dispatchEvent(new Event("cart-update", {bubbles: true}))
		})
	}
}

customElements.define("product-form-component", ProductForm)

class QuickProductForm extends HTMLElement {
	constructor() {
		super()
		this.form = this.querySelector("form")
		this.submitButton = this.querySelector(".submit-form")
		this.formObject = {}
	}

	connectedCallback() {
		this.form.addEventListener("submit", async $event => {
			$event.preventDefault()
			$event.stopPropagation()

			if (this.form.classList.contains("loading")) return

			this.form.classList.add("loading")

			const data = {}
			const formData = new FormData(this.form)
			formData.forEach((value, key) => {
				this.formObject[key] = value
			})

			data.id = this.formObject["id"]
			data.quantity = this.formObject["quantity"]

			if (this.formObject.subscription === "subscription") {
				data.selling_plan = this.formObject["frequency"]
			}

			data.sections = "cart-drawer"

			const cartAddRequest = await fetch("/cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			}).then(res => res.json())
			this.form.classList.remove("loading")

			// Parse it as HTML so we can grab only what's inside
			const html = cartAddRequest.sections["cart-drawer"]
			const parser = new DOMParser()
			const doc = parser.parseFromString(html, "text/html")
			document.querySelector("cart-drawer").replaceWith(doc.querySelector("cart-drawer"))
			document.querySelector("cart-drawer").openDrawer()

			if (document.querySelector("cart-drawer")) {
				document.querySelector("cart-drawer").open()
				return document.dispatchEvent(new Event("cart-update", {bubbles: true}))
			}
		})

		this.form.addEventListener("change", $event => {
			const formData = new FormData(this.form)
			formData.forEach((value, key) => {
				this.formObject[key] = value
			})

			if (this.formObject.subscription === "subscription") {
				this.submitButton.querySelector(".one-time-price").classList.add("hidden")
				this.submitButton.querySelector(".subscription-price").classList.remove("hidden")
			}

			if (this.formObject.subscription === "one-time-purchase") {
				this.submitButton.querySelector(".one-time-price").classList.remove("hidden")
				this.submitButton.querySelector(".subscription-price").classList.add("hidden")
			}

			console.log("Changed the form")
		})
	}
}

customElements.define("product-form", QuickProductForm)
